module.exports = __webpack_public_path__ + "img/235.bf2ac128.jpg";